export default __webpack_public_path__ + "static/media/brand_itau.5a8936c4.svg";